import { render, staticRenderFns } from "./SelectTournamentTeamModal.vue?vue&type=template&id=65e52c91&scoped=true&"
import script from "./SelectTournamentTeamModal.vue?vue&type=script&lang=js&"
export * from "./SelectTournamentTeamModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectTournamentTeamModal.vue?vue&type=style&index=0&id=65e52c91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e52c91",
  null
  
)

export default component.exports